import React from 'react';
import { Checkbox, CheckboxProps } from '@grubhubprod/gh-cookbook-react';
import { Control, Controller, RegisterOptions } from 'react-hook-form';
import { toggleValueInArray } from 'src/utilities/toggleValueInArray';

interface DeprecatedCookbookCheckboxWrapperProps extends CheckboxProps {
  name: string;
  control: Control;
  rules?: RegisterOptions;
}

/**
 * @deprecated DeprecatedCookbookCheckboxWrapper
 *
 * This Component has been deprecated in favour of the CookbookCheckboxWrapper.
 */
export const DeprecatedCookbookCheckboxWrapper = ({
  name,
  control,
  rules,
  indeterminate,
  ...cookbookCheckboxProps
}: DeprecatedCookbookCheckboxWrapperProps): JSX.Element => {
  const handleOnChange = () => {
    control.setValue(
      name,
      Array.isArray(control.getValues(name))
        ? toggleValueInArray(
            control.getValues(name),
            cookbookCheckboxProps.value
          )
        : !control.getValues(name)
    );
  };

  const isChecked = Array.isArray(control.getValues(name))
    ? control.getValues(name).includes(cookbookCheckboxProps.value)
    : !!control.getValues(name);

  return (
    <Controller
      name={name}
      rules={rules}
      control={control}
      render={({ ...field }) => {
        return (
          <Checkbox
            {...field}
            {...cookbookCheckboxProps}
            onChange={handleOnChange}
            checked={isChecked}
            indeterminate={indeterminate && isChecked}
            value={field.value}
          />
        );
      }}
    />
  );
};
